/**
 * Get color (black/white) depending on bgColor so it would be clearly seen.
 * @param bgColor
 * @returns {string}
 */
 export function getColorByBgColor(bgColor: string) {
  if (!bgColor) {
    return "";
  }
  return parseInt(bgColor.replace("#", ""), 16) > 0xffffff / 1.5
    ? "#000"
    : "#fff";
}

export function getColorByBgColorScrollbar(bgColor: string) {
  if (!bgColor) {
    return "";
  }
  return parseInt(bgColor.replace("#", ""), 16) > 0xffffff / 1.5
    ? "#343a40"
    : "#d8d8d8";
}

export function getColorFromStr(str: string) {
  let hash = 0,
    color = "#";

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 255;
    color += ("00" + value.toString(16)).substr(-2);
  }
  return color;
}

// function to return if color is in hexadecimal format and does not have spaces nor commas
export function validateColorHexadecimal(color: string): boolean {
  const conditions = [" ", ","];
  return (
    /([a-fA-F0-9]{3}){1,2}\b/.test(color) &&
    !conditions.some((condition) => color.includes(condition))
  );
}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
